import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, Article } from './index';

export interface ArticleByIdGetParams {
  id: string;
}

export const articleById = (payload: ArticleByIdGetParams): Action<ArticleByIdGetParams> => ({
  type: actions.articleByIdTrigger.toString(),
  payload,
});

export const articleByIdClear = (): Action => ({
  type: actions.articleByIdClear.toString(),
});

export const articleByIdErrorClear = (): Action => ({
  type: actions.articleByIdErrorReset.toString(),
});

export function* articleByIdRequestSaga({ payload }: Action<ArticleByIdGetParams>) {
  yield put({
    type: actions.articleByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.articleByIdError.toString(),
      payload: {
        message: 'ArticleById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<Article, Article>(
    response,
    actions.articleByIdSuccess.toString(),
    actions.articleByIdError.toString(),
    false,
    (articleByIdData) => articleByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.articleByIdTrigger.toString(),
    defaultProcessingSaga(
      articleByIdRequestSaga,
      {
        error: actions.articleByIdError.toString(),
        locationCancel: actions.articleByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.articleByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.articleByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.articleByIdErrorReset.toString(),
    });
  });
}
